import React, { useState, useRef, useEffect } from "react"
import content from "../../content"
import DfbIcon from "../ui-kit/dfb_icon"
import { slugify } from "../../helper/string"

/**
 * Will render the anchor navigation component when at least one of the provided
 * sections contains an anchor_name value.
 * @param sections
 * @return {JSX.Element}
 */
const MAnchorNavigation = ({ sections }) => {
  const inputId = "mAnchorNavigation"
  const baseClass = "m-AnchorNavigation"
  const labelClass = `${baseClass}-label`
  const iconClass = `${baseClass}-icon`
  const [isOpen, setIsOpen] = useState(true)

  const node = useRef()

  const anchorNames = sections
    ?.map((section) => section.anchor_name)
    ?.filter((anchorName) => anchorName)

  const handleClickOutside = (e) => {
    if (node && node.current && node.current.contains(e.target)) {
      // inside click
      return
    }
    // outside click
    setIsOpen(false)
  }

  const handleAnchorClick = () => {
    const desktopMediaQuery = window.matchMedia("(min-width: 576px)")
    if (!desktopMediaQuery.matches) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  if (!anchorNames || anchorNames.length < 1) {
    return null
  }

  const iconTypes = {
    open: "add",
    close: "remove",
  }

  return (
    <div className={baseClass} ref={node}>
      <input
        className={`${baseClass}-input`}
        type="checkbox"
        id={inputId}
        tabIndex={1}
        checked={isOpen}
        onChange={() => setIsOpen(!isOpen)}
      />
      <label className={`${baseClass}-button`} htmlFor={inputId}>
        {["open", "close"].map((key) => (
          <span className={`${labelClass} ${labelClass}--${key}`} key={key}>
            {content.anchorNavigation[key]}
          </span>
        ))}
        {["open", "close"].map((key) => (
          <DfbIcon
            icon_type={iconTypes[key]}
            add_class={`${iconClass} ${iconClass}--${key}`}
            key={key}
          />
        ))}
      </label>
      <ul className={`${baseClass}-list`}>
        {anchorNames.map((anchorName) => {
          const anchorId = slugify(anchorName)
          return (
            <li className={`${baseClass}-item`} key={anchorId}>
              <a
                className={`${baseClass}-link`}
                href={`#${anchorId}`}
                tabIndex={1}
                onClick={handleAnchorClick}
              >
                {anchorName}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default MAnchorNavigation
